import { render, staticRenderFns } from "./AppItemSearch.vue?vue&type=template&id=0b586dfa&scoped=true&"
import script from "./AppItemSearch.vue?vue&type=script&lang=js&"
export * from "./AppItemSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b586dfa",
  null
  
)

export default component.exports